<div class="app-common-viewer-container" [ngClass]="hideEditForm?'hideSideFormCss':''">
  @if (currentData && currentData.showBanner) {
    <div>
      @if (currentData.bannerJson.component == undefined) {
        <app-resource-banner
        [bannerJson]="currentData.bannerJson"></app-resource-banner>
      }
    </div>
  }
  @if (currentData['resouceDef'] && currentData['resouceDef'].config!=undefined && !showImageView) {
    <div class="d-flex mb-2 mt-2"
      [ngClass]="checkNavigationExist('back_navigation') ? 'justify-content-between' : 'justify-content-end'"
      >
      @if (checkNavigationExist('back_navigation')) {
        <div class="item-flex page-title">
          <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
            <img src="assets/images/grid-back.png" />
          </a>
          {{baseService._currentTitle}}
        </div>
      }
    </div>
  }
  <!-- Search & buttons-->
  <div [ngClass]=" utilService.isMobile() ? '_mobileView' : ''">
    @if (!showImageView) {
      <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer _search_block"
        [ngClass]="showHistory==false?'justify-content-end':''">
        @if (utilService.isMobile()) {
          <div class="d-flex w-100 justify-content-end">
            @if (archiveConfig.catalogue_code != undefined) {
              <div class="table-quick-actions-web">
                <button (click)="showArchivePolicy()" type="button" class="btn-with-icon-label">
                  <i class="fa fa-folder-open" aria-hidden="true"></i>
                  <span class="">{{((archiveConfig.selected != undefined && archiveConfig.selected.label != undefined)?archiveConfig.selected.label:'cur_data') | translate | async}}</span>
                </button>
                <div [class.show]="archiveConfig.open == true"
                  class="dropdown-menu paginationCount archieve-dropdown">
                  @for (achList of archiveConfig.list; track achList) {
                    <div class="dropdown-item" (click)="setArchivePolicy(achList)">{{achList.label |
                    translate | async }}</div>
                  }
                </div>
              </div>
            }
            @if (archiveConfig.catalogue_code == undefined) {
              @if (currentData!=undefined && currentData['resouceDef']!=undefined && currentData['resouceDef'].config!=undefined && currentData['resouceDef'].config.journey_info!=undefined && rolePermissionService.checkAccessPermission('archived_emr','patient_journey','emr')) {
                <button
                  class="btn-with-icon-label _arch-btn" title="View Archived Data" (click)="archivalRedirection()">
                  <i class="fa fa-file-archive-o" aria-hidden="true"></i>
                  <span>Archived Data</span>
                </button>
              }
            }
            @if (currentData.secondary_uhid  && rolePermissionService.checkAccessPermission('secondary_uhid',currentResource,this.appService.getApplication())) {
              <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                (click)="secondaryUhidBtn();"
                style="display:flex;flex-direction: column;align-items: end;margin-right: 0rem !important;">
                <input class="custom-control-input" type="checkbox" [checked]=currentData.secondary_uhid_default>
                <label class="custom-control-label custom_secondary_class" style="padding-left: 45px;"></label>
                <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">{{'Merge UHID' |
                translate | async}}</p>
              </div>
            }
            @if (currentData.ehr_view_button && rolePermissionService.checkAccessPermission('ehr_view',currentResource,this.appService.getApplication())) {
              <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                (click)="toggleAutoRefresh();"
                style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
                <input class="custom-control-input" type="checkbox" [checked]=currentData.ehr_view>
                <label class="custom-control-label" style="padding-left: 45px;"></label>
                <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">EHR</p>
              </div>
            }
            @if (rolePermissionService.checkAccessPermission('pdf_order_view',currentResource,this.appService.getApplication())) {
              <div class="pdf_order_view custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                (click)="pdfOrderView($event);"
                style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
                <input class="custom-control-input" type="checkbox" [checked]=currentData.pdf_order_view>
                <label class="custom-control-label" style="padding-left: 25px;"></label>
                <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 5px !important;">PDF View</p>
              </div>
            }
          </div>
        }
        <div class="cursor-pointer m-0 p-0" [hidden]="showHistory == false">
          <div class="pr-2 d-flex align-items-center">
            <div class="pr-2 pl-1 back_navigation_common_viewer" style="height: 20px;">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
                <!--img src="assets/images/grid-back.png" /-->
              </a>
            </div>
            <div class="w-100 mb-1 history-label" [ngClass]="{'history-label-bulk-active': labBulkPrintItem.length > 0}">{{'field.label.history' | translate | async }}
            ({{currentData.count?currentData.count:0}})</div>
          </div>
          @if (currentResource == 'template_assessment' || currentResource == 'progress_note'|| currentResource == 'initial_assessment_final' || currentResource == 'discharge_summary' || currentResource == 'package_note_emr' || currentResource == 'surgery_note_emr' || currentResource == 'template_assessment_final' || currentResource == 'pac_template' || currentResource == 'certificate' || currentResource == 'template_assessment_procedure') {
            <div class="filter-orderset flex-1"
              >
              <div class="radio-action-container">
                <div class="radio-container flex-wrap" style="padding: 10px;">
                  <label class="radio-wrapper">All
                    <input type="radio" checked name="basedOn" (change)="getFilterBasedData('all')">
                    <span class="check-mark-radio"></span>
                  </label>
                  <label class="radio-wrapper">Self
                    <input type="radio" name="basedOn" (change)="getFilterBasedData('filter_based:self')">
                    <span class="check-mark-radio"></span>
                  </label>
                  <label class="radio-wrapper">Clinical Note
                    <input type="radio" name="basedOn" (change)="getFilterBasedData('filter_based:clinical_note')">
                    <span class="check-mark-radio"></span>
                  </label>
                  <label class="radio-wrapper">Nursing Note
                    <input type="radio" name="basedOn" (change)="getFilterBasedData('filter_based:nursing_note')">
                    <span class="check-mark-radio"></span>
                  </label>
                </div>
              </div>
            </div>
          }
          @if (config.filterAr != undefined && config.filterAr.length) {
            <div class="bookmarks-container ml-2 mr-2">
              <div class="col-12 p-0">
                @for (filter of config.filterAr; track filter) {
                  <div class="fav-bookmark">
                    <div class="bookmark-chip" [ngClass]="filter.name == config.filterConfig.FilterName ? 'active': ''"
                      style="cursor: pointer;">
                      <span class="" (click)="applyQuickFilter(filter)"> {{ filter.name }}</span>
                      <!-- <i class="fa fa-filter" (click)="applyFilter(filter)"></i> -->
                      <!-- (click)="resetFilter(filter)" -->
                      @if (filter.name == config.filterConfig.FilterName) {
                        <i class="fa fa-check ml-1"></i>
                      }
                    </div>
                  </div>
                }
                @if (config.localStorageData && config.localStorageData['filter__'] != undefined && config.localStorageData['filter__'].length >0) {
                  <a href="javascript:void(0)" (click)="manageFilter()"
                    >
                    <img src="assets/images/icon-context.svg">
                  </a>
                }
              </div>
            </div>
          }
          <div class="d-flex align-items-center mb-2">
            @if (currentData['resouceDef'] && (currentData['resouceDef'].config.search == undefined || currentData['resouceDef'].config.search || currentData['resouceDef'].config.search == '' || (this.currentData['filterBlock'] != undefined))) {
              <div class="grid-search-wrapper"
                [ngClass]="{'no-search':currentData['resouceDef'].config.hideSearchBox,'has-filter':this.currentData['filterBlock'] != undefined}"
                >
                <div class="_filter-button-wrapper">
                  @if (this.currentData['filterBlock'] != undefined) {
                    <div class="_filter-button" (click)="displayFilter()">
                      <!-- <span class="filter-text">Filter</span> -->
                      <i class="fa fa-filter" aria-hidden="true"></i>
                    </div>
                  }
                </div>
                <div [hidden]="currentData['resouceDef'].config.hideSearchBox" class="_complex-search">
                  <app-complex-search [config]="currentData['resouceDef'].config" (onFilterChange)="filterClick($event);"
                    #complexSearch>
                  </app-complex-search>
                </div>
              </div>
            }
          </div>
          <div class="filter-grid">
            <ng-container>
              <div class="col-12 pl-4 pr-4"
                [hidden]="!(this.currentData['filterBlock'] != undefined && this.currentData['filterBlock'].default_open)"
                (clickOutside)="displayFilter()">
                <div class="row grid_filter">
                  <div class="filter-body">
                    <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
                    <span class="close-filter-btn" (click)="displayFilter()">
                      <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                      @if (this.currentData['filterBlock']) {
                        <div class="filter-form">
                          <kx-filter [config]="{}" (getData)="getDataFn($event)" [fields]="this.currentData['filterBlock']"
                            (getFilter)="doSearch($event);displayFilter()" [persistValue]="config"
                            (resetFilter)="resetFilter($event);displayFilter()">
                          </kx-filter>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          @if (!utilService.isMobile() && this.currentPrescription !={} && this.dialogConfig && this.dialogConfig.type && this.dialogConfig.type == 'order_medicine') {
            <div
              class="prescription">
              <!---Import prescription button---->
              <button (click)="getMedicationDetails()" type="button" class="btn btn-primary btn-sm text-right">Import
              Prescription</button>
            </div>
          }
          <div>
            @if (!utilService.isMobile()) {
              <div class="table-quick-actions-web d-flex">
                @if (archiveConfig.catalogue_code != undefined) {
                  <button (click)="showArchivePolicy()" type="button" class="btn-with-icon-label">
                    <i class="fa fa-folder-open" aria-hidden="true"></i>
                    <span class="">{{((archiveConfig.selected != undefined && archiveConfig.selected.label != undefined)?archiveConfig.selected.label:'cur_data') | translate | async}}</span>
                  </button>
                  <div [class.show]="archiveConfig.open == true"
                    class="dropdown-menu paginationCount archieve-dropdown">
                    @for (achList of archiveConfig.list; track achList) {
                      <div class="dropdown-item" (click)="setArchivePolicy(achList)">{{achList.label |
                      translate | async }}</div>
                    }
                  </div>
                }
                @if (archiveConfig.catalogue_code == undefined) {
                  @if (currentData!=undefined && currentData['resouceDef']!=undefined && currentData['resouceDef'].config!=undefined && currentData['resouceDef'].config.journey_info!=undefined && rolePermissionService.checkAccessPermission('archived_emr','patient_journey','emr')) {
                    <button
                      class="btn-with-icon-label _arch-btn" title="View Archived Data" (click)="archivalRedirection()">
                      <i class="fa fa-file-archive-o" aria-hidden="true"></i>
                      <span>Archived Data</span>
                    </button>
                  }
                }
                @if (currentData.secondary_uhid  && rolePermissionService.checkAccessPermission('secondary_uhid',currentResource,this.appService.getApplication())) {
                  <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                    (click)="secondaryUhidBtn();"
                    style="display:flex;flex-direction: column;align-items: end;margin-right: 0rem !important;">
                    <input class="custom-control-input" type="checkbox" [checked]=currentData.secondary_uhid_default>
                    <label class="custom-control-label custom_secondary_class" style="padding-left: 45px;"></label>
                    <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">{{'Merge UHID' |
                    translate | async}}</p>
                  </div>
                }
                @if (currentData.ehr_view_button && rolePermissionService.checkAccessPermission('ehr_view',currentResource,this.appService.getApplication())) {
                  <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                    (click)="toggleAutoRefresh();"
                    style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
                    <input class="custom-control-input" type="checkbox" [checked]=currentData.ehr_view>
                    <label class="custom-control-label" style="padding-left: 45px;"></label>
                    <p class="m-0 p-0" style="margin-top: 25px !important;padding-left: 20px !important;">EHR</p>
                  </div>
                }
                @if (rolePermissionService.checkAccessPermission('pdf_order_view',currentResource,this.appService.getApplication())) {
                  <div class="pdf_order_view custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch"
                    (click)="pdfOrderView($event);"
                    style="display:flex;flex-direction: column;align-items: end;margin-right: 2rem !important;">
                    <input class="custom-control-input" type="checkbox" [checked]=currentData.pdf_order_view>
                    <label class="custom-control-label" style="padding-left: 25px;"></label>
                    <p class="m-0 p-0" style="margin-top: 25px !important;">PDF View</p>
                  </div>
                }
              </div>
            }
            @if (!dischargePatientList && !viewOnly && currentData['resouceDef'] && currentData['resouceDef'].config.add_required && checkExpressionForAdd() && rolePermissionService.checkAccessPermission('add',currentResource,this.appService.getApplication())) {
              <div
                class="mb-1 d-flex justify-content-end">
                <!--button in case of grid : added by abhinav chauhan-->
                @if (!utilService.isMobile()) {
                  <button class="primary-btn" (click)="addRequiredButton()">
                    <span>{{(currentData['resouceDef'].config.addButton)?currentData['resouceDef'].config.addButton:'button.add'
                      |
                    translate | async}}</span>
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  </button>
                }
                <!--for mobile fixed button-->
                @if (utilService.isMobile();) {
                  <button class="mobile-primary-btn" (click)="addRequiredButton()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    <div>{{(currentData['resouceDef'].config.addButton)?currentData['resouceDef'].config.addButton:'button.add'
                      |
                    translate | async}}</div>
                  </button>
                }
              </div>
            }
            @if (!utilService.isMobile() && currentData['resouceDef'] && currentData['resouceDef'].config.action_buttons != undefined && this.currentData['selectedList'] != undefined && this.currentData['selectedList'] != {}) {
              <div class="row pull-right">
                @if (currentData.addendum_history_show && !currentData['hideDropdown'] && currentData.VersionList!=undefined && currentData.VersionList.length!=undefined && currentData.resouceDef!=undefined && currentData.resouceDef.config!=undefined&& currentData.resouceDef.config.definalize!=undefined && rolePermissionService.checkAccessPermission('version',currentResource,this.appService.getApplication())) {
                  <div class="addendum-history">
                    <button type="button" class="form-select" style="max-width: 170px; font-size: 14px !important; border: 1px solid #444;"
                      (click)="addendumHistoryOpen = !addendumHistoryOpen" (blur)="addendumHistoryOpen = false">
                      {{currentData.versionVal ? addendumHistoryLabel : 'Addendum History'}}
                    </button>
                    @if (addendumHistoryOpen) {
                      <ul (mousedown)="$event.preventDefault()">
                        <li [class.active]="!currentData.versionVal" (click)="addendumHistoryOpen = false; currentData.versionVal = ''; versionChange('')">Addendum History</li>
                        @for (option of currentData.VersionList; track option; let i = $index) {
                          <li [class.active]="option.id === currentData.versionVal" (click)="addendumHistoryOpen = false; addendumHistoryLabel = (option.templateName || option.template_name) + ' | ' + option.template_version; currentData.versionVal = option.id; versionChange(option.id)">{{option.templateName ||
                            option.template_name}}&nbsp;
                            | &nbsp; {{option.template_version}}&nbsp;
                            | &nbsp; {{ ((i === 0 && option.template_creation_date_time) ? (option.template_creation_date_time) : (option.g_modify_time)) | dateTimeFormat}}&nbsp;
                            | &nbsp; {{option.g_created_by_name}}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
                @if (currentData.resouceDef!=undefined && currentData.resouceDef.config!=undefined&& currentData.resouceDef.config.card_view!=undefined && currentData.resouceDef.config.card_view!='false') {
                  <div class="table-view-toggle">
                    <!-- <ng-template #swithcToCard>
                    Switch Card Layout
                  </ng-template>
                  <ng-template #swithcToTable>
                    Switch Table Layout
                  </ng-template>
                  <span class="toggle-icn">
                    <i *ngIf="currentData && currentData.gridConfig && currentData.gridConfig.activeField == 'table'"
                      class="fa fa-th" (click)="cardViewChange('tile');" [popover]="swithcToCard" placement="left"
                    container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
                    <i *ngIf="currentData && currentData.gridConfig && currentData.gridConfig.activeField == 'tile'"
                      class="fa fa-list" (click)="cardViewChange('table');" [popover]="swithcToTable" placement="left"
                    container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
                  </span>
                  -->
                  @if (currentData && currentData.gridConfig && currentData.gridConfig.activeField == 'table') {
                    <button type="button"
                      class="btn-with-icon-label" (click)="cardViewChange('tile');">
                      <i aria-hidden="true" class="fa fa-th"></i>
                      <span>{{'card_view' | translate | async }}</span>
                    </button>
                  }
                  @if (currentData && currentData.gridConfig && currentData.gridConfig.activeField == 'tile') {
                    <button type="button"
                      class="btn-with-icon-label" (click)="cardViewChange('table');">
                      <i aria-hidden="true" class="fa fa-list"></i>
                      <span>{{'table_view' | translate | async }}</span>
                    </button>
                  }
                </div>
              }
              @for (buttons of currentData['resouceDef'].config.action_buttons; track buttons) {
                <div class="mr-2"
                  [ngClass]="{'cancel_hide_button':cancel_button_hide}">
                  @if (showBtn(buttons) && rolePermissionService.checkAccessPermission((buttons.action_name != undefined ? buttons.action_name : buttons.action),(buttons.checkResource ? buttons.checkResource : currentResource),this.appService.getApplication()) && ((buttons.action == 'view' && utilService.isMobile()) ||buttons.action != 'view')&& (((buttons.action == 'print' || buttons.action == 'view' || buttons.showAtView) && viewOnly) || !viewOnly)) {
                    <button
                      type="button" class="btn-with-icon-label" (click)="onButtonClicked(buttons, undefined, entity, $event)">
                      @if (buttons.icon_name) {
                        <img class="icon-name-width" src={{buttons.icon_name}} />
                        }@if (buttons.icon_name) {
                        <span
                          class="iconText">{{buttons.label | translate |
                        async}}</span>
                      }
                      @if (buttons.class) {
                        <i aria-hidden="true" [class]="buttons.class"><span class="iconText">{{buttons.label
                          | translate |
                        async}}</span></i>
                      }
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- content -->
    <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer">
      @if (!showImageView) {
        <div class="cursor-pointer m-0 p-0 max-width-card" id="scrollTestLab" [hidden]="showHistory==false"
          scroll-directive>
          @if (currentData.list && currentData.list.length > 0) {
            <div>
              <div class="_wf-historyheading-epricription-viwer mb-2" [ngClass]="{'_wf-historyheading-epricription-viwer-with-banner': visibleforTat(currentData.cardData.tag_data)}">
                <span class="flex-grow-1">
                  <button class="primary-btn-viwer mr-2"  [attr.disabled]="pagination.page_no==0 ? '' : null " (click)="goPrev() "><i
                  class="fa fa-angle-double-left"></i></button>
                  @if (!utilService.isMobile()) {
                    <button class="primary-btn-viwer" [attr.disabled]="checkPreviousButton()" (click)="prevImage() "><i
                    class="fa fa-angle-left"></i></button>
                  }
                </span>
                <ng-container>({{((pagination.page_no?pagination.page_no:0)*10)+pagination.selected_index+1}}/{{currentData.count?currentData.count:0}})</ng-container>
                <span class="flex-grow-1">
                  <button class="primary-btn-viwer ml-2 float-right" [attr.disabled]="getClassToEnableDisableIcon()"
                    (click)="goNext()"><i class="fa fa-angle-double-right"></i></button>
                    @if (!utilService.isMobile()) {
                      <button class="primary-btn-viwer float-right" [attr.disabled]="checkNextButton()" (click)="nextImage() "><i
                      class="fa fa-angle-right"></i></button>
                    }
                  </span>
                  @if (selectedItemsForCumulativePrint.length > 0 && currentData && currentData.cumulativePrintCheckbox) {
                    <!-- Add this after the history heading section, before the list -->
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-top: 7px; padding-top: 6px; border-top: 2px solid #5CBAF1;">
                      <!-- Select All / Deselect All Toggle -->
                      <div style="display: flex; justify-content: center; align-items: center; gap: 4px; padding-left: 2px;">
                        <input
                          type="checkbox"
                          id="selectAllCheckbox"
                          style="width: 16px; height: 16px;"
                          [checked]="isAllSelected()"
                          [disabled]="isCumulativePrinting"
                          (change)="toggleSelectAll($event)">
                        <label style="font-size: 16px;" for="selectAllCheckbox">
                          Select All
                        </label>
                      </div>
                      <!-- Print Button -->
                      <button
                        class="primary-btn"
                        style="margin: 0 !important; font-size: 15px !important;"
                        [disabled]="selectedItemsForCumulativePrint.length === 0 || isCumulativePrinting"
                        (click)="printSelectedItems()">
                        <i class="{{isCumulativePrinting ? 'fa fa-circle-o-notch fa-spin' : 'fa fa-print'}}" style="margin-right: 4px !important; color: white !important;"></i>
                        Print ({{getSelectedCount()}})
                      </button>
                    </div>
                  }
                </div>
                @for (entity of currentData.list; track entity; let i = $index) {
                  <div #activeTab class="_wf-historytab doc-view-list row"
                    id="labtestList checkactive{{i}}"
                    [ngClass]="isExpandableField ? { 'card-expanded': entity._expanded,'card-collapsed': !entity._expanded, 'doc-active-tab': !this.utilService.isMobile() && i == activeValue } : { 'doc-active-tab': !this.utilService.isMobile() && i == activeValue }"
                    (click)="!this.utilService.isMobile() ? [hitSecondaryDataSource(entity,i), activeTab.classList.toggle('doc-active-tab')] : mobileEventCall(entity)">
                    <!-- for small screens show action buttons -->
                    @if (utilService.isMobile()) {
                      <div class="w-100">
                        <div class="_card-actions-container d-block pull-right">
                          <div class="card-three-dots-container card-action"  (click)="toggleMenu($event, dropdownMenuRef)">
                            <i aria-hidden="true" class="fa fa-ellipsis-v"></i>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="_table-quick-actions" #dropdownMenuRef style="width: 100%;">
                      <div class="_table-quick-actions-items">
                        @for (buttons of currentData['resouceDef'].config.action_buttons; track buttons) {
                          @if (((showBtn(buttons,entity) && rolePermissionService.checkAccessPermission((buttons.action_name != undefined ? buttons.action_name : buttons.action),currentResource,this.appService.getApplication())) || (buttons.action == 'view')) && (((buttons.action == 'print' || buttons.action == 'view' || buttons.showAtView) && viewOnly) || !viewOnly)) {
                            <button type="button"
                              class="btn-with-icon-label" (click)="onButtonClicked(buttons, undefined, entity, $event)">
                              <i aria-hidden="true" [class]="buttons.class"></i>
                              <span>{{buttons.label | translate | async}}</span>
                            </button>
                          }
                        }
                      </div>
                    </div>
                    @if (currentData && currentData.cumulativePrintCheckbox) {
                      <input
                        type="checkbox"
                        [id]="'checkbox_' + i"
                        [(ngModel)]="entity.selected"
                        (change)="onCheckboxChange(entity, i, $event)"
                        [disabled]="isCumulativePrinting"
                        style="width: 16px; height: 16px;"
                        class="mt-1"
                        (click)="$event.stopPropagation()">
                    }
                    @if (!isExpandableField) {
                      <div class="_m-card-body" (click)="mobileRowClick($event, entity)">
                        @for (field of currentData.fields; track field) {
                          @if (checkExpression(field,entity) && ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') && !((field?.name === 'template_version' || field?.name === 'isDefinalize') && currentData.card_fields_hide) && !(field.name === 'g_modified_by_name' && currentData.card_fields_hide)) {
                            <div
                              [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-historytabheading' : '_wf-historytableft'">
                              @if (field.show_heading == undefined || field.show_heading) {
                                <span class="wf0historycategory">
                                {{field.heading|translate|async}}</span>
                              }
                              <ng-template #showPopover>{{entity | mapvalue: field}}</ng-template>
                              @if ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') {
                                <div
                                  [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-cf-heading' : field.capitalize?'_wf-historybolddata text-capitalize':'_wf-historybolddata'"
                                  [ngStyle]="getStyle(field,entity)" [popover]="field.show_popover?showPopover:null"
                                  triggers="mouseenter:mouseleave" placement="top left"
                                  container="body">{{entity | mapvalue: field}}
                                  @if (field && (!field.iconExpression || checkIconExpression(field, entity))) {
                                    <span>
                                      @if (field.sub_icon_name) {
                                        <span>
                                          <span class="pl-1" [popover]="field.show_sub_popover?(field.sub_popover_data |translate|async):null"
                                            triggers="mouseenter:mouseleave" placement="top left" container="body">
                                            <img class="sub-icon-card" [src]="'assets/images/'+field.sub_icon_name"
                                              [alt]="field.show_sub_popover?(field.sub_popover_data |translate|async):''">
                                          </span>
                                        </span>
                                      }
                                    </span>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if ((field.type == 'datetime' || field.type == 'compositeDatetime') && !(field.name === 'g_creation_time' && resource && resource.resource == 'progress_note' && currentData.card_fields_hide) && !(field.name === 'g_modify_time' && currentData.card_fields_hide)) {
                            <div class="_wf-historytableft">
                              <div class="wf0historycategory">{{field.heading |translate|async }}</div>
                              <div class="_wf-historybolddata">{{entity | mapvalue : field | dateTimeFormat}}</div>
                            </div>
                          }
                          @if (field.type == 'event' && checkExpression(field,entity)) {
                            <div class="_wf-historytableft">
                              <div class="_wf-historybolddata"><a href="javascript:void(0)"
                              (click)="eventHandler(entity,field)"> {{field.heading |translate|async}}</a>
                                @if (field.sub_icon_name && (!field.iconExpression || checkIconExpression(field, entity) || field.sub_icon_name_false)) {
                                  <span class="pl-1"
                                    [popover]="(checkIconExpression(field, entity) ? field.sub_popover_fields : field.sub_popover_fields_false) ? dynamicSubPopover : (field.show_sub_popover?((checkIconExpression(field, entity) ? field.sub_popover_data : field.sub_popover_data_false) |translate|async):null)"
                                    triggers="mouseenter:mouseleave" placement="top left" container="body">
                                    <img class="sub-icon-card" [src]="'assets/images/'+(checkIconExpression(field, entity) ? field.sub_icon_name : (field.sub_icon_name_false || ''))"
                                      [alt]="field.show_sub_popover?((checkIconExpression(field, entity) ? field.sub_popover_data : field.sub_popover_data_false) |translate|async):''">
                                  </span>
                                  <!-- Entity-driven popover: opt in via sub_popover_fields[_false]
                                       ([{label, key|static, format?}]) for row-specific text sub_popover_data
                                       (a plain string) can't hold. Not wrapped in its own @if - a #ref inside
                                       a structural block isn't visible to the [popover] binding above it. -->
                                  <ng-template #dynamicSubPopover>
                                    @for (row of (checkIconExpression(field, entity) ? field.sub_popover_fields : field.sub_popover_fields_false); track row.label) {
                                      <div>{{row?.label |translate|async}}: {{row?.static ? (row.static |translate|async) : (row?.format == 'date' ? (entity?.[row.key] | dateFormat) : row?.format == 'time' ? (entity?.[row.key] | timeFormat) : row?.format == 'dateTime' ? (entity?.[row.key] | dateTimeFormat) : entity?.[row?.key])}}</div>
                                    }
                                  </ng-template>
                                }
                              </div>
                            </div>
                          }
                          @if (field.type == 'viewDicom' && checkExpression(field,entity)) {
                            <div class="_wf-historytableft">
                              <div class="_wf-historybolddata"><a href="javascript:void(0)"
                              (click)="viewDicom(entity,field); $event.stopPropagation()">{{field.heading |translate|async}}</a></div>
                            </div>
                          }
                          @if (field.type == 'smartReport' && checkExpression(field,entity)) {
                            <div class="_wf-historytableft">
                              <div class="_wf-historybolddata"><a href="javascript:void(0)"
                              (click)="smartReport(entity,field); $event.stopPropagation()">{{field.heading |translate|async}}</a></div>
                            </div>
                          }
                          @if (field.type == 'seenReport' && checkExpression(field,entity) && rolePermissionService.checkAccessPermission('report_seen_unseen',currentResource,appService.getApplication())) {
                            <div class="_wf-historytableft">
                              <div class="_wf-historybolddata">
                                <a href="javascript:void(0)" class="pl-1" [popover]="checkIconExpression(field,entity)?seenReportPopover:null"
                                  triggers="mouseenter:mouseleave" placement="top left" container="body"
                                  (click)="markReportSeen(entity,field); $event.stopPropagation()">
                                  <i class="fa" [ngClass]="checkIconExpression(field,entity)?'fa-eye':'fa-eye-slash'"></i>
                                </a>
                                <ng-template #seenReportPopover>
                                  <div>{{'field.label.seen_status' |translate|async}}: {{'field.label.seen' |translate|async}}</div>
                                  <div>{{'field.label.seen_by' |translate|async}}: {{entity['seenBy']}}</div>
                                  <div>{{'field.label.seen_on' |translate|async}}: {{entity['seenOn'] | dateTimeFormat}}</div>
                                </ng-template>
                              </div>
                            </div>
                          }
                        }
                      </div>
                    }
                    @if (isExpandableField && this?.currentData?.resouceDef?.list?.mobile_card_view_Field) {
                      <div class="_m-card-body" (click)="mobileRowClick($event, entity)">
                        <app-mobile-card-template-view  [item]="entity" [resourceName]="currentResource"></app-mobile-card-template-view>
                      </div>
                    }
                    @if (isExpandableField) {
                      <div class="card-toggle-btn" (click)="expandCard(entity, i, $event)" title="Expand">
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- for pdf -->
        @if (currentData.show && currentData.selectedList) {
          <div class="_wf-patienthistory box-shadow"
            id="scrollTestLab " scroll-directive [ngClass]="dialogConfig?.data?.inPopup != true?'':'position-relative'">
            @if (this.utilService.isMobile() && dialogConfig?.data?.inPopup != true) {
              <div
                [ngClass]="(this.currentPrescription !={} && this.dialogConfig && this.dialogConfig.type && this.dialogConfig.type == 'order_medicine')?'with-action-button ':'without-action-button'">
                @if (this.currentPrescription !={} && this.dialogConfig && this.dialogConfig.type && this.dialogConfig.type == 'order_medicine') {
                  <div
                    >
                    <button (click)="getMedicationDetails()" type="button" class="btn btn-primary btn-sm">Import
                    Prescription</button>
                  </div>
                }
                <div class="crossbutttoninhistory">
                  <i aria-hidden="true" class="fa fa-times-circle" style="font-size: 1.5em;" (click)="closeButton()"></i>
                </div>
              </div>
            }
            @if (!isPrintOpenInPopup && currentData.selectedList && currentData.selectedList.view_selected_config && currentData.selectedList.view_selected_config.type != undefined && currentData.selectedList.view_selected_config.type == 'pdf') {
              <div
                style="height:100%">
                <!-- TODO:- need to move it in document viewer -->
                @if (currentData.selectedList.url != undefined) {
                  <ng2-pdfjs-viewer pdfSrc="{{currentData.selectedList.url }}"
                  [openFile]="false" [download]="currentData.viewerDownload" [print]="currentData.viewerPrint"></ng2-pdfjs-viewer>
                }
              </div>
            }
            @if (noObservationFound !=true && currentData.selectedList && currentData.selectedList.view_selected_config && currentData.selectedList.view_selected_config.type != undefined && currentData.selectedList.view_selected_config.type == 'grid' && currentData.gridCardData && currentData.gridCardFields) {
              <div
                style="height:100%">
                <dhs-data-grid
                  [data]="currentData.gridConfig.key_to_use && !showImageView?{resource:currentData.gridCardData.resource[0][currentData.gridConfig.key_to_use]}:currentData.gridCardData"
                  [bulkActionsConfig]="currentData.bulkAction"
                  (bulkActionClicked)="onBulkActionClicked($event)"
                  [fields]="currentData.gridCardFields" [config]="currentData.gridConfig"
                (editEllipseClick)="buttonAction($event)"></dhs-data-grid>
              </div>
            }
            <!-- for image -->
            @if (!isPrintPopupActive && currentData.selectedList && currentData.selectedList.view_selected_config && currentData.selectedList.view_selected_config.type == 'image' && currentData.selectedList.documentIds) {
              <app-document-viewer
                [multiDocumentId]="currentData.selectedList.documentIds" [config]="currentData.configForDocument">
              </app-document-viewer>
            }
            <!-- for form view -->
            @if (currentData.selectedList && currentData.selectedList.view_selected_config && currentData.selectedList.view_selected_config.type == 'form' && currentData.formViewData != undefined && currentData.selectedList != undefined && noObservationFound==false) {
              <div
                >
                <dhs-form-view [data]="currentData.selectedList.template" [fieldGroup]="currentData.formViewData"
                [buttonConf]=false></dhs-form-view>
              </div>
            }
            @if (noObservationFound==true) {
              <div class="no-record-found-img-container text-center">
                <img src="assets/images/nodata-icon.svg" class="no-records-found" />
                <div class="no-records-found-text">
                  <span>{{'field.label.no_records_found' | translate | async}}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- {{currentData.list}} -->
    @if (currentData.list && currentData.list.length == 0) {
      <div class="no-record-found">
        <div class="no-record-found-img-container">
          <img src="assets/images/nodata-icon.svg" class="no-records-found" />
          <div class="no-records-found-text">
            <span>{{'field.label.no_records_found' | translate | async}}</span>
          </div>
        </div>
      </div>
    }
  </div>